import a from "./CouponFeatured.vue2.js";
import { openBlock as l, createElementBlock as c, Fragment as p, renderList as i, createElementVNode as o, createTextVNode as n, toDisplayString as t } from "vue";
/* empty css                    */
import u from "../../_virtual/_plugin-vue_export-helper.js";
const d = /* @__PURE__ */ o("br", null, null, -1), _ = { class: "Galyon" }, h = /* @__PURE__ */ o("br", null, null, -1), m = { style: { "font-size": "19px" } }, f = {
  class: "Galyon-Bold",
  style: { color: "#5d8ef9" }
}, C = ["onClick"], y = ["src"];
function x(s, g, b, k, $, B) {
  return l(!0), c(p, null, i(s.couponShowCaseList, (e, r) => (l(), c("section", {
    key: r,
    class: "coupon-main-box education-section"
  }, [
    o("div", null, [
      o("h3", null, [
        n(t(e.head) + " ", 1),
        d,
        n(t(e.result), 1)
      ]),
      o("p", _, [
        n(t(e.phrase1) + " ", 1),
        h,
        o("span", m, [
          n(" USE CODE: "),
          o("span", f, t(e.couponCode), 1)
        ])
      ]),
      o("input", {
        type: "button",
        class: "clip-btn clipped Galyon-Bold",
        value: "CLIP COUPON",
        onClick: (E) => s.CopyCoupon(e.couponCode)
      }, null, 8, C),
      o("img", {
        src: e.imagePath,
        alt: "",
        style: { "max-width": "220px", "max-height": "120px" },
        class: "img-fluid"
      }, null, 8, y)
    ])
  ]))), 128);
}
const O = /* @__PURE__ */ u(a, [["render", x]]);
export {
  O as default
};
